<template>
  <div class="d-flex flex-column mb-5">
    <div class="d-flex flex-column">
      <v-card class="d-flex mb-10 align-center pa-4" v-for="(n, i) in selected.education">
        <div class="d-flex flex-column flex-grow-1 mr-1">
          <div class="d-flex mb-2">
            <v-text-field
              v-model="n.university"
              label="University"
              outlined
              dense
              hide-details
              class="mr-1"
            ></v-text-field>
            <v-text-field
              v-model="n.faculty"
              label="Faculty"
              outlined
              dense
              hide-details
            ></v-text-field>
          </div>
          <div class="d-flex mb-2">
            <v-card outlined class="mr-3">
              <div class="pa-3 font-weight-bold">From date:</div>
              <v-date-picker
                v-model="n.from_date"
                type="month"
                min="1990-00"
              ></v-date-picker>
            </v-card>
            <v-card outlined>
              <div class="pa-3 font-weight-bold">To date:</div>
              <v-date-picker
                v-model="n.to_date"
                type="month"
                min="1990-00"
              ></v-date-picker>
            </v-card>
          </div>
        </div>
        
        <v-btn @click="selected.education = selected.education.filter((n, z_i) => z_i !== i)" fab small color="error">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </v-card>
      <div class="d-flex">
        <v-spacer></v-spacer>
        <v-btn 
          depressed 
          @click="selected.education.push({
            university: '',
            faculty: '',
            from_date: '',
            to_date: '',
          })" 
          color="primary"
        >
          add
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      
    }
  },
  computed: {
    ...mapGetters({
      selected: 'devs/selected',
      mode: 'devs/mode',
      showModal: 'devs/showModal',
    }),
  },
}
</script>

<style>

</style>